export default {
    "中文": "中文"
}